import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const clearDrafts = () => Object.keys(sessionStorage).filter((k) => k.startsWith("camryn-start-")).forEach((k) => sessionStorage.removeItem(k));

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const authVersion = useRef(0);

  const refresh = useCallback(async () => {
    const v = authVersion.current;
    try {
      const { data } = await api.get("/auth/me");
      if (v === authVersion.current) setUser(data);
      return data;
    } catch {
      if (v === authVersion.current) setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    authVersion.current += 1;
    setUser(data);
    return data;
  };
  const register = async (name, email, password, consents) => {
    const { data } = await api.post("/auth/register", { name, email, password, ...consents });
    authVersion.current += 1;
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    clearDrafts();
    authVersion.current += 1;
    setUser(false);
  };
  const updateProfile = async (patch) => {
    const { data } = await api.put("/profile", patch);
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, refresh, login, register, logout, updateProfile }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
